import { render, staticRenderFns } from "./SelfiePrompt.vue?vue&type=template&id=3cdb8b92"
import script from "./SelfiePrompt.vue?vue&type=script&lang=js"
export * from "./SelfiePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports